import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

export type RoomVendor = 'lessonspace' | 'hilink';

export interface OpenSpaceRequest {
  id?: string;
  providerId: string;
  providerName: string;
  locale: string;
  darkmode: boolean;
  vendor?: RoomVendor;
}

export interface JoinSpaceRequest {
  name: string;
  userId?: string;
  locale: string;
  darkmode: boolean;
}

@Injectable({ providedIn: 'root' })
export class RoomDoorService {
  private readonly http = inject(HttpClient);

  get configured(): boolean {
    return environment.lessonspaceDoorUrl.length > 0;
  }

  openSpace(request: OpenSpaceRequest): Observable<{ id: string; providerUrl: string }> {
    return this.http.post<{ id: string; providerUrl: string }>(
      `${environment.lessonspaceDoorUrl}/spaces`,
      request
    );
  }

  joinSpace(
    roomId: string,
    request: JoinSpaceRequest
  ): Observable<{ clientUrl: string; userId: string }> {
    return this.http.post<{ clientUrl: string; userId: string }>(
      `${environment.lessonspaceDoorUrl}/spaces/${encodeURIComponent(roomId)}/join`,
      request
    );
  }

  space(roomId: string): Observable<{ providerUrl: string } | null> {
    return this.http
      .get<{ providerUrl: string }>(
        `${environment.lessonspaceDoorUrl}/spaces/${encodeURIComponent(roomId)}`
      )
      .pipe(catchError(() => of(null)));
  }
}
